import { API_BASE_URL } from '../config'
import axios from 'axios'
// import { normalizeResponseErrors } from './utils'

export const UPDATE_COMMENTS = 'UPDATE_COMMENTS'
export const updateComments = update => ({
	type: UPDATE_COMMENTS,
	update
})

export const sendCommentToApi = (commentObj) => dispatch => {
	const { rating, value, uid, item, isEdit } = commentObj
	return axios
			.post(`${API_BASE_URL}/comment/${item}`, {
				rating,
				body: value,
				uid,
				isEdit
			})
			.then(res => {
				res.data.isEdit = isEdit
				dispatch(updateComments(res.data))
			})
}

export const sendEditedCommentToApi = (commentId, itemId, newComment, isEdit) => dispatch => {
	return axios
			.put(`${API_BASE_URL}/comment/${itemId}/${commentId}`, {
				newComment,
				isEdit
			})
			.then(res => {
				res.data.isEdit = isEdit
				dispatch(updateComments(res.data))
			})
}

export const deleteCommentFromApi = (commentId, itemId, isEdit) => dispatch => {
	return axios
			.post(`${API_BASE_URL}/comment/${itemId}/${commentId}`, {
				isEdit
			})
			.then(res => {
				res.data.isEdit = isEdit
				dispatch(updateComments(res.data))
			})
}


// WEBPACK FOOTER //
// ./src/actions/comments.js